export const GET_AVAILABILITIES = "GET_AVAILABILITIES";
export const GET_AVAILABILITY_BY_ID = "GET_AVAILABILITY_BY_ID";
export const UPDATE_AVAILABILITY = "UPDATE_AVAILABILITY";
export const DELETE_AVAILABILITY = "DELETE_AVAILABILITY";
export const CREATE_AVAILABILITY = "CREATE_AVAILABILITY";
